<template>
  <el-form
    :model="formData"
    :rules="rules"
    ref="formData"
    label-position="left"
    label-width="0px"
    class="demo-ruleForm login-container"
  >
    <div class="language">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          Language<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="zh_cn">中文</el-dropdown-item>
          <el-dropdown-item command="en_us">English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <h3 class="title">{{ $t("dealer.dealer_login") }}</h3>
    <el-form-item prop="phone">
      <el-input
        type="text"
        v-model="formData.phone"
        auto-complete="off"
        :placeholder="$t('username')"
      ></el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input
        type="password"
        v-model="formData.password"
        auto-complete="off"
        :placeholder="$t('password')"
      ></el-input>
    </el-form-item>
    <el-checkbox v-model="checked" checked class="remember">{{
      $t("remember_me")
    }}</el-checkbox>
    <el-form-item style="width: 100%">
      <el-button
        type="primary"
        style="width: 100%"
        @click.native.prevent="handleSubmit"
        >{{ $t("login") }}</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        phone: "",
        password: "",
      },
      rules: {
        phone: [
          {
            required: true,
            message: this.$t("message.please_enter_username"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("message.please_enter_password"),
            trigger: "blur",
          },
        ],
      },
      checked: true,
    };
  },
  created: function () {
    this.updateTitle();
  },
  methods: {
    handleCommand(command) {
      this.setLocale(command);
      this.updateTitle();
    },
    updateTitle() {
      document.title = this.$t("dealer.dealer_login");
    },
    handleSubmit(ev) {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.api.dealer.user
            .login(Object.assign({}, this.formData))
            .then((response) => {
              if (response.data.errorCode == 0) {
                this.$store.commit({
                  type: "loginIn",
                  name: response.data.data.name,
                  userName: response.data.data.phone,
                  id: response.data.data.id,
                  token: response.data.data.token,
                });
                this.$router.replace({ path: "main" });
              }
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.login-container {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  height: 330px;
  width: 300px;
  padding: 15px;
  border-radius: 5px;
  background-clip: padding-box;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

.title {
  margin: 10px auto 30px;
  text-align: center;
  color: #505458;
  font-size: 18px;
}

.remember {
  margin: 0px 0px 35px 0px;
}
.language {
  text-align: right;
  line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// Login.vue?41071a88